var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("profile-container-loader")
        : _c(
            "div",
            { staticClass: "row" },
            [
              _c("profile-picture", {
                attrs: { "user-details": _vm.userDetails },
                on: {
                  "submit-upload": _vm.handleUploadProfilePhoto,
                  "submit-remove": _vm.handleRemoveProfilePhoto,
                },
              }),
              _vm._v(" "),
              _c("change-password", {
                ref: "changePasswordForm",
                on: {
                  submit: _vm.handlePasswordSubmit,
                  "initial-submit": _vm.handleSubmit,
                  "allow-save": _vm.handleAllowSave,
                  "form-change": _vm.handleFormChange,
                },
              }),
              _vm._v(" "),
              _c("personal-details", {
                ref: "personalDetailsForm",
                attrs: {
                  "user-details": _vm.userDetails,
                  "account-details": _vm.accountDetails,
                  "loading-saving": _vm.loading,
                  portal: "client",
                },
                on: {
                  submit: _vm.handlePersonalDetailsSubmit,
                  "initial-submit": _vm.handleSubmit,
                  "allow-save": _vm.handleAllowSave,
                  "form-change": _vm.handleFormChange,
                },
              }),
              _vm._v(" "),
              _c("language-preferences", {
                ref: "languagePreferencesForm",
                attrs: { "account-details": _vm.accountDetails },
                on: {
                  submit: _vm.handleLanguagePreferencesSubmit,
                  "initial-submit": _vm.handleSubmit,
                  "allow-save": _vm.handleAllowSave,
                  "form-change": _vm.handleFormChange,
                },
              }),
              _vm._v(" "),
              _c("div"),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }